module.exports = __webpack_public_path__ + "media/images/logo/flash-peel-a2b200329047fd23f5a9520abeb6cbf8.svg";